import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message',
		defaultMessage:
			"We couldn't load your starred filters. <link>Refresh the page</link> to try again.",
		description:
			"This text is displayed in a section message when we are unable to load the user's starred filters. The <link> and </link> tags enclose a link that will trigger a page refresh, and these tags should be kept in the translated message surrounding the corresponding translated text.",
	},
	starredFiltersHeader: {
		id: 'spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header',
		defaultMessage: 'Starred filters',
		description: 'Header of the starred/favourite global filters navigation section',
	},
});
